import React, {useEffect, useState} from 'react';
import { useHistory } from 'react-router-dom';

// bootstrap
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

// redux
import { useSelector, useDispatch, } from 'react-redux';
import { selectDeleteStatus, getConversations, getMessages, selectConversations, selectSelectedConversation, selectMessages, selectMessage, setSelectedConversation, setMessage, postMessage, clearSelectedConversation, selectSendMessageStatus, selectShowArchive, archiveChat, deleteChat, selectArchiveChatStatus, selectNotificationStatus} from "_redux/slices/messaging/messaging";
import { selectFirebaseUser, selectIata, selectUserDb } from '_redux/slices/main-screen/user';
import { setUser } from '../../../redux/slices/profile/user-profile';

// exterior libraries
import { Title as TremorTitle, Subtitle, Flex, Toggle, ToggleItem } from '@tremor/react';

// styling
import { Colors, Spacing, Typography } from '_styles';

// molecules
import { CustomModal } from '_molecules';

import { formatTimestamp } from '_utils/date-time-functions';

// icons
import { FaUserCircle } from "react-icons/fa";
import { FaArchive } from "react-icons/fa";
import { FaTrashAlt } from "react-icons/fa";
import { MdUnarchive } from "react-icons/md";

const ChatHeader = (props) => {

    // nav
    const history = useHistory();

    // redux
    const dispatch = useDispatch();

    const iata = useSelector(selectIata);

    const selectedConversation = useSelector(selectSelectedConversation);
    const deleteStatus = useSelector(selectDeleteStatus);
    const archiveChatStatus = useSelector(selectArchiveChatStatus);
    const showArchive = useSelector(selectShowArchive)
    const notificationStatus = useSelector(selectNotificationStatus);

    // states
    const [deleted, setDeleted] = useState(false);
    const [archived, setArchived] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    // flight info state vars
    const [flightTime, setFlightTime] = useState('');
    const [departureDate, setDepartureDate] = useState('');
    const [airline, setAirline] = useState('');
    const [flightNumber, setFlightNumber] = useState('');
    const [flightType, setFlightType] = useState('');
    const [departureAirport, setDepartureAirport] = useState('');
    const [arrivalAirport, setArrivalAirport] = useState('');

    const [showSuccessModal, setShowSuccessModal] = useState(false);


    const archiveSelectedChat = () => {
        setArchived(true)
        dispatch(archiveChat({conversationId:selectedConversation.id, 'archive': true}))
    }

    const activateSelectedChat = () => {
        setArchived(true)
        dispatch(archiveChat({conversationId: selectedConversation.id, 'archive': false}))
    }

    const deleteConversation = () => {
        setDeleted(true)
        console.log('deleting selectedConversation:', selectedConversation)
        setShowDeleteModal(false);
        dispatch(deleteChat(selectedConversation.id))
    }

    const refreshConversations = () => {
        dispatch(clearSelectedConversation())
        setShowSuccessModal(false)
        dispatch(getConversations({iata}));
    }

    const showProfile = () => { 
        if(selectedConversation && selectedConversation.userId){
            dispatch(setUser(selectedConversation.userId))
            history.push('/user-profile')
        }
    }

    useEffect(() => {
        console.log('status:', deleteStatus)
        if(deleteStatus == 'succeeded' && deleted){
            // show success modal and fetch conversations again
            setShowDeleteModal(false);
            setShowSuccessModal(true)
        }
        if(deleteStatus == 'failed' && deleted){
            // show error modal
        }
    }, [deleteStatus]);

    useEffect(() => {
        console.log('status:', archiveChatStatus)
        if(archiveChatStatus == 'succeeded' && archived){
            // show success modal and fetch conversations again
            refreshConversations();
        }
        if(archiveChatStatus == 'failed' && archived){
            // show error modal
        }
    }, [archiveChatStatus]);


    useEffect(() => {
        if(selectedConversation && selectedConversation.flightDate != undefined && selectedConversation.flightNumber != undefined && selectedConversation.airline != undefined && selectedConversation.departureTime != undefined && selectedConversation.type != undefined && selectedConversation.departureAirport != undefined && selectedConversation.arrivalAirport != undefined){
            console.log('timestamp, ', selectedConversation.departureTime)
        }
    }, [selectedConversation]);

    useEffect(() => {
        if(selectedConversation && selectedConversation.flightDate != undefined && selectedConversation.flightNumber != undefined && selectedConversation.airline != undefined && selectedConversation.departureTime != undefined && selectedConversation.type != undefined && selectedConversation.departureAirport != undefined && selectedConversation.arrivalAirport != undefined){
            setFlightTime(formatTimestamp(selectedConversation.departureTime));     
            setDepartureDate(selectedConversation.flightDate);   
            setAirline(selectedConversation.airline);   
            setFlightNumber(selectedConversation.flightNumber);     
            setFlightType(selectedConversation.type);      
            setDepartureAirport(selectedConversation.departureAirport);     
            setArrivalAirport(selectedConversation.arrivalAirport);
        }
        else {
            setFlightTime(""); setDepartureDate(""); setAirline(""); setFlightNumber(""); setFlightType(""); setDepartureAirport(""); setArrivalAirport("");
        }
    }, [selectedConversation]);

    return (
        <>
        <Row style={{ marginLeft:Spacing.SCALE_4, padding:Spacing.SCALE_12, borderStyle:'solid', borderBottomWidth:1, borderTopWidth:0, borderLeftWidth:0, borderRightWidth:0, borderColor:Colors.GRAY_LIGHT}}>
            <Col xs={4}>
                <div>

                    <div style={{ display:'flex'}}>
                        <p style={{
                            fontSize:22, 
                            fontWeight:'bold', 
                            textAlign:'left', 
                            color: 'black' 
                        }}>{airline + '' + flightNumber}</p>
                        <div style={{height:10, width:10, borderRadius:25, marginTop:Spacing.SCALE_12, backgroundColor:Colors.PRM_LIGHT_BLUE,  marginLeft:Spacing.SCALE_8, marginRight:Spacing.SCALE_8}} />
                        <p style={{
                            fontSize:22, 
                            fontWeight:'bold', 
                            textAlign:'left', 
                            color: 'black' 
                        }}>{departureAirport + ' - ' + arrivalAirport}</p>
                    </div>

                    <div style={{ display:'flex', marginTop:-Spacing.SCALE_8 }}>
                        <p style={{
                                fontSize:16, 
                                fontWeight:'400', 
                                textAlign:'left', 
                                color: 'black',
                                opacity:0.6
                            }}>{departureDate}</p>
                        <div className='mt-2' style={{height:5, width:5, borderRadius:25, backgroundColor:'black', opacity:0.4, marginLeft:Spacing.SCALE_8, marginRight:Spacing.SCALE_8}} />
                        <p style={{
                                fontSize:16, 
                                fontWeight:'400', 
                                textAlign:'left', 
                                color: 'black',
                                opacity:0.6
                            }}>{flightTime}</p>
                    </div>
                    
                </div>
            </Col>
            <Col>
                <Row>
                    <Col xs={8}>
                    </Col>
                    <Col>
                        <div style={{ display:'flex', justifyContent:'space-evenly' }}>
                            <FaUserCircle size={32} onClick={()=> showProfile()} color={Colors.GRAY_DARK} style={{cursor:'pointer'}} />
                            { !showArchive ? <FaArchive size={32} onClick={archiveSelectedChat} color={Colors.GRAY_DARK} style={{cursor:'pointer'}} /> : <MdUnarchive size={32} onClick={activateSelectedChat} color={Colors.GRAY_DARK} style={{cursor:'pointer'}} /> }
                            <FaTrashAlt size={32} onClick={()=>{setShowDeleteModal(true)}} style={{cursor:'pointer'}} color={Colors.GRAY_DARK} />
                        </div>
                    </Col>
                </Row>
            </Col>
        </Row>
        
        {/* Delete Modal */}
        <CustomModal 
            hide={()=>{setShowDeleteModal(false)}} 
            show={showDeleteModal}
            title={'Delete Passenger Chat'}
            body={'Once a passenger chat has been deleted it cannot be recovered. Consider archiving this chat instead of permanently deleting it.'}
            button={'Delete'}
            buttonVariant={'danger'}
            openButton={deleteConversation}
            close={()=>{setShowDeleteModal(false)}}
            status={'loading'}
        />

        {/* Success Modal */}
        <CustomModal 
            hide={refreshConversations} 
            show={showSuccessModal}
            title={'Successfully Deleted Passenger Chat'}
            body={'The passenger chat has been successfully deleted.'}
            button={'Done'}
            openButton={refreshConversations}
        />

        </>
    );
};

export default ChatHeader;
